import React, { useState } from "react";
import {
  ChakraProvider,
  Box,
  Text,
  VStack,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Grid,
  IconButton,
  Tooltip,
  Button,
  Input,
  Textarea,
  Icon,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Divider,
} from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import DraggableBooleanCreationElement from "./components/questionCreationComponents/DraggableBooleanCreationElement";
import DraggableTextCreationElement from "./components/questionCreationComponents/DraggableTextCreationElement";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { ChatIcon, QuestionIcon } from "@chakra-ui/icons";
import { v4 as uuidv4 } from "uuid";
import { FaSave } from "react-icons/fa";
import { ViewIcon, RepeatIcon } from "@chakra-ui/icons";
import SurveyPreviewModal from "./SurveyPreviewModal";
import SaveUpdateSurveyModal from "./SaveUpdateSurveyModal";
import { useTranslation } from "react-i18next";
import { VscSymbolBoolean } from "react-icons/vsc";
import { PiFileHtmlBold  } from "react-icons/pi";
import DraggableRankingDropdownRadiogroupCheckboxCreationElement from "./components/questionCreationComponents/DraggableDropdownRadiogroupCheckboxCreationelement";
import {  getSurveyADP, initSurveyService, updateSurveyConsensus } from "../../services/http/surveyHttpService";
import logout from "../../services/authService";
import createAxiosInstance from "../../interceptors/useAxiosInterceptors";
import { useNavigate } from "react-router-dom";
import { useSession } from "../../SessionContext";
import { useDisclosure } from "@chakra-ui/react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import DraggableHtmlCreationElement from "./components/questionCreationComponents/DraggableHtmlCreationElement";
import DraggableDatePickerCreationElement from "./components/questionCreationComponents/DraggableDatePickerCreationElement";
import { MdArrowDropDown } from "react-icons/md";
function SurveyConsensusUpdateComponent() {

 
  const {t} = useTranslation();
  const { 
    isOpen: isOpenModalDiscardChangesSurvey, 
    onOpen: onOpenModalDiscardChangesSurvey, 
    onClose: onCloseModalDiscardChangesSurvey 
  } = useDisclosure();  
  const options = ["html","text" , "boolean", "dropdown"];
  const toast = useToast();
  const [isModalPreviewOpen, setModalPreviewOpen] = useState(false)

  const [isModalSaveSurveyOpen, setModalSaveSurveyOpen] = useState(false)

  const [isDraft, setIsDraft] = useState(false)

  
  const { clearSessionData} = useSession();
  const { id } = useParams(); 


  useEffect(() => { 
    
    if(id != null) {
      getSurveyADP({id_survey_info: id }).then(res => {
        
        
        if(res && res.message && res.message.survey_structure) 
          
         
   
          setSurvey(res.message.survey_structure)
      })    
        
    }

    
   
     }, []);

  const navigate = useNavigate();



  const axiosInstance = createAxiosInstance(async (axiosInstance)=> {

    logout(t, clearSessionData,navigate,toast,axiosInstance)
  });

  initSurveyService(t, toast, axiosInstance)

  const cleanSurveyState = {
     title: "",
     description: "",
     pages: [
           {
               title: "Benvenuto nel progetto “Voce agli esperti”!",
               elements: [{
                 "id": uuidv4(),
                 "type": "html",
                 "name": "suggestions-auto-grow",
                 "title": "Benvenuto nel progetto “Voce agli esperti”!",
                
                  "html": "Questa indagine è coordinata dal Dipartimento di [Facoltà] dell’ [Nome-Università], in collaborazione con [Nome-Azienda]., nonché la Fondazione GRINS, nell’ambito del progetto “GRINS – Growing Resilient, Inclusive and Sustainable”, di cui è soggetto attuatore la Fondazione GRINS, finanziato dal PNRR nello spettro delle scienze economiche-politico-sociali e delle scienze dei dati.\
  L\'indagine ha l’obiettivo di raccogliere le opinioni di esperti provenienti dal mondo accademico, istituzionale e industriale su temi economici e finanziari di attualità. I risultati contribuiranno a offrire una prospettiva qualificata al grande pubblico, favorendo una maggiore comprensione delle dinamiche economiche e finanziarie.\
 Pensiamo che il tuo contributo sia essenziale per il successo del progetto.\
  Grazie per la tua partecipazione!\
  Il team di ricerca\
 Per maggiori approfondimenti sul progetto di ricerca, si rinvia al Modulo informativo per la partecipazione disponibile al seguente link <a href=\"https://www.example2.com\" target=\"_blank\" rel=\"noopener noreferrer\">Modulo informativo per la partecipazione</a>,  da considerarsi parte integrante della presente informativa.\
 L\'informativa, disponibile al seguente link <a href=\"https://www.example.com\" target=\"_blank\" rel=\"noopener noreferrer\">Informativa-Privacy</a>, è stata elaborata ai sensi dell’art. 13 del Regolamento (UE) 2016/679 “relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali, nonché alla libera circolazione di tali dati” (di seguito, “GDPR”) e del D.lgs. 196/2003, come modificato dal D.lgs. 101/2018 (di seguito, “Codice Privacy”).",
                 "rows": 2,
                 "autoGrow": true,
                 "allowResize": false,
                 "readOnly": true,
               },
       /*{
         title: "Informativa sul trattamento dei dati personali",
         elements: [{
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow",
           "title": "Attività di ricerca nel progetto GRINS: “The Floor to the Experts”",
           "html": "Lei è invitata/o a partecipare a una ricerca denominata “The Floor to the Experts”, che intende studiare il processo di scelta individuale dei soggetti , condotta dal Dipartimento di Scienze Economiche dell’Alma Mater Studiorum – Università di Bologna, in collaborazione con Prometeia S.p.A., nonché la Fondazione GRINS, nell’ambito del progetto “GRINS – Growing Resilient, Inclusive and Sustainable”, di cui è soggetto attuatore la Fondazione GRINS, finanziato dal PNRR nello spettro delle scienze economiche-politico-sociali e delle scienze dei dati, al fine di fornire evidenze che orientino le politiche pubbliche, nonché le scelte di cittadini e aziende in contesti decisionali complessi, contribuendo a una crescita del Paese più resiliente, inclusiva e sostenibile.\r\nPer maggiori approfondimenti sul progetto di ricerca, si rinvia al Modulo informativo per la partecipazione, da considerarsi parte integrante della presente informativa.\r\n\r\nLa presente informativa è stata elaborata ai sensi dell’art. 13 del Regolamento (UE) 2016/679 “relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali, nonché alla libera circolazione di tali dati” (di seguito, “GDPR”) e del D.lgs. 196/2003, come modificato dal D.lgs. 101/2018 (di seguito, “Codice Privacy”).\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },*/
       
        /* {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow1",
           "title": "Soggetti del trattamento",
           "description": "Titolari del trattamento",
           "html": "•\tAlma Mater Studiorum – Università di Bologna (di seguito, “Unibo”), con sede legale a Bologna, via Zamboni 33, C.F. 80007010376, privacy@unibo.it, pec: scriviunibo@pec.unibo.it, il cui Data Protection Officer (o Responsabile della Protezione dei Dati) è contattabile via e-mail all’indirizzo dpo@unibo.it;\r\n•\tPrometeia S.p.A. (di seguito, “Prometeia”), con sede legale a Bologna, piazza Trento e Trieste 3, C.F. e P. IVA 03118330376, privacy@prometeia.com, pec: prometeia@legalmail.it, il cui Data Protection Officer (o Responsabile della Protezione dei Dati) è contattabile via e-mail all’indirizzo dpo@prometeia.com; \r\n•\tFondazione di partecipazione denominata “GRINS – Growing Resilient, Inclusive and Sustainable” (di seguito, “Fondazione GRINS”), con sede legale a Bologna, Galleria Ugo Bassi n. 1, C.F. 91451720378, info@grins.it, pec: fondazionegrins@pec.grins.it, il cui Data Protection Officer (o Responsabile della Protezione dei Dati) è contattabile via e-mail all’indirizzo dpo@grinsfoundation.it.\r\nIn particolare, Unibo, Prometeia e Fondazione GRINS sono contitolari del trattamento rispetto alle sottoindicate finalità (A), (B), (C), (D) mentre sono titolari autonomi in relazione alla finalità (E).\r\nÈ a sua disposizione, richiedendolo a mezzo e-mail ai recapiti dei Contitolari, il contenuto essenziale dell’accordo di contitolarità, ai sensi dell’art. 26, comma 2 del GDPR.\r\n\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         }
         ,
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow2",
           "title": "Dati personali oggetto del trattamento",
           "html": "I suoi dati personali che saranno trattati sono i seguenti: dati identificativi, codice fiscale, dati di contatto, genere, ruolo e ambito lavorativo, provenienza geografica.\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
 
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow3",
           "title": "Finalità del trattamento",
           "description": "I suoi dati personali saranno trattati per i seguenti fini:",
           "html": "(A) Partecipazione alla ricerca e popolamento della piattaforma AMELIA nell’ambito del progetto “GRINS – Growing Resilient, Inclusive and Sustainable”\r\nQualora lei decida di prendere parte alla ricerca in questione, i suoi dati personali raccolti mediante apposito form saranno utilizzati per consentire la sua partecipazione al progetto. In particolare, lei riceverà un sondaggio online condotto attraverso la piattaforma AMELIA. I dati personali raccolti mediante il sondaggio saranno oggetto di pseudonimizzazione (sostituzione dei dati identificativi con un codice) e saranno elaborati per popolare la piattaforma e produrre i risultati della ricerca. \r\nI dati raccolti potranno essere trattati, solo se strettamente necessario per finalità di gestione tecnica del sistema informatizzato, da soggetti appositamente autorizzati con funzioni di amministrazione del sistema.\r\nLa piattaforma AMELIA è una infrastruttura open data ad alta tecnologia realizzata nell’ambito del progetto “GRINS – Growing Resilient, Inclusive and Sustainable”, volta a creare e trasferire conoscenza tra ricercatori, imprese, individui e istituzioni attraverso l’accesso, l’utilizzo e la combinazione e l’analisi di dati, potenza computazionale, algoritmi avanzati. Il progetto GRINS, difatti, prevede che le Università e gli altri enti impegnati nelle attività di ricerca all’interno degli 8 Spoke tematici conferiscano nella piattaforma AMELIA dati e risultati prodotti nel corso delle attività di progetto (ad esempio: le fonti primarie, i dati intermedi, le analisi statistiche, i codici software e i deliverable finali), per consentire ai Contitolari di effettuare, tramite l’uso di tale piattaforma, politiche approfondite di analisi e modellizzazione e di perseguire gli scopi previsti nel progetto medesimo.\r\nPer maggiori informazioni sulla piattaforma AMELIA, si prega di prendere visione della pagina tematica sul sito istituzionale della Fondazione GRINS: https://grins.it/progetto/piattaforma-amelia.\r\nI dati personali raccolti in forma identificativa e caricati sulla piattaforma AMELIA nonché i risultati (oggetto anche di pseudonimizzazione) per la finalità (A) saranno conservati fino al termine del progetto GRINS, attualmente previsto per il 31 dicembre 2025 (salvo proroghe), salvo l’adempimento di obblighi di legge (finalità E). Tuttavia, se utili al progetto, per i periodi indicati nelle successive finalità (B) o, previo suo consenso, (C). \r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
 
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow4",
           "title": "(A2) Anonimizzazione dei dati personali raccolti nel corso della ricerca",
           "html": "Ai fini della ricerca sopra descritta, i Contitolari potranno pubblicare in forma aggregata e anonima i risultati e, pertanto, si renderà necessario, nel corso dell’avanzamento progetto GRINS ed entro la sua conclusione, procedere all’anonimizzazione e aggregazione dei dati personali raccolti. A seguito del processo di anonimizzazione, i Contitolari potranno elaborare, ad esempio, pubblicazioni scientifiche e statistiche nonché realizzare conferenze scientifiche utilizzando i risultati della ricerca in forma aggregata e anonima al fine di metterli a disposizione del pubblico. \r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow5",
           "title": "(B) Valorizzazione dei risultati di ricerca confluiti nella piattaforma “AMELIA”",
           "html": "Al termine del progetto GRINS, come obiettivo di quest’ultimo, è intenzione dei Contitolari gestire e valorizzare il patrimonio informativo della piattaforma AMELIA, consistente nei risultati delle ricerche del progetto GRINS. \r\nA tal fine, i Contitolari proseguiranno, oltre la durata del progetto GRINS, la gestione della piattaforma AMELIA e la conservazione dei dati ivi confluiti e memorizzati adottando le più idonee misure di sicurezza, per permettere il corretto funzionamento e la piena fruibilità della piattaforma.\r\nI risultati contenenti dati personali saranno, previa pseudonimizzazione, conservati per 10 anni dalla conclusione di questo progetto, per poi essere cancellati o anonimizzati nel rispetto della finalità A2. In ogni caso, si evidenzia come non rientri nella finalità dei Contitolari mantenere la Sua identificabilità e, dunque, a seguito del caricamento dei dati sulla piattaforma AMELIA, potrebbe non essere più tecnicamente possibile identificarLa, anche ai fini dell’art. 11 del GDPR.\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow6",
           "title": "(C) Memorizzazione dei dati per future iniziative correlate alla piattaforma AMELIA",
           "html": "Considerando che, in futuro, potrebbero emergere nuove opportunità di valorizzazione, anche commerciale, della piattaforma AMELIA, consentendo l’accesso e la fruizione del suo patrimonio a soggetti terzi (come descritto nella finalità D)), è possibile consentire una conservazione prolungata dei dati per 15 anni dalla conclusione di questo studio per, se necessario, contattarla nuovamente per acquisire, ove ritenuto di suo interesse, un nuovo consenso se identificato come idonea base giuridica, un nuovo consenso specifico.\r\nIn mancanza di consenso, i suoi dati verranno cancellati o resi anonimi alla scadenza del termine di conservazione indicato al punto (B).\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow7",
           "title": "(D) Valorizzazione commerciale della piattaforma per garantire l’accesso e la fruizione del patrimonio a soggetti terzi",
           "html":"Previo suo consenso alla memorizzazione dei dati personali, i dati afferenti le ricerche, potranno essere trattati nell’ottica della condivisione in favore degli utenti della piattaforma per ulteriori finalità di ricerca scientifica, o comunque di interesse pubblico se applicabile ad uno o più die Contitolari, rispetto alle quali il futuro riuso di eventuali dati personali dovrà essere fondato su un’idonea e corretta base giuridica. Ove applicabile queste ultime casistiche, i Contitolari Le forniranno tutte le informazioni necessarie sul trattamento dei suoi dati personali. \r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow8",
           "title": "(E) Conservazione a fini amministrativi",
           "html":"I suoi dati personali saranno inoltre trattati per scopi di contabilità amministrativa e conservati per il tempo strettamente necessario al perseguimento di tali scopi, ad eccezione del periodo di dieci anni per garantire i requisiti fiscali, contabili e amministrativi richiesti dalla legge.\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow9",
           "title": "Base giuridica e natura del conferimento dei dati",
           "description": "Finalità (A):",
           "html":"La base giuridica risiede nella necessità di eseguire un compito di interesse pubblico, ai sensi dell’art. 6.1, lett. e) del GDPR. La ricerca “The Floor to the Experts”, come anticipato, è svolta nel contesto del Progetto GRINS, il quale è finanziato dal Piano Nazionale di Ripresa e Resilienza (PNRR, Missione 4, Componente 2, Investimento 1.3).\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow10",
           "title": "Finalità (A2):",
           "html":"Essendo la pubblicazione dei risultati della ricerca in forma anonima e aggregata un esplicito obiettivo della ricerca stessa, nonché del progetto GRINS, la finalità di anonimizzazione dei dati personali raccolti in corso di progetto è da considerarsi compatibile alla finalità al punto 1 ai sensi degli artt. 5.1, lett. b) e 6.4 del GDPR.\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow11",
           "title": "Finalità (B):",
           "html":"Essendo la valorizzazione dei risultati della ricerca del progetto GRINS un esplicito obiettivo dello stesso progetto finanziato dal PNRR, la conservazione dei dati ai fini della valorizzazione scientifica è da considerarsi compatibile alla finalità (A) ai sensi degli artt. 5.1, lett. b) e 6.4 del GDPR.\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow12",
           "title": "Finalità (C):",
           "html":"La base giuridica risiede nel consenso, ai sensi dell’art. 6.1, lett. a) del GDPR. \r\nIl conferimento del consenso è facoltativo e ci consente di conservare i suoi dati personali per un periodo più lungo di quello previsto per la conclusione del presente studio al fine di garantire future iniziative correlate alla piattaforma AMELIA e, se necessario, di ricontattarla per farle esprimere, se lo ritiene, un nuovo consenso specifico in relazione a tali future iniziative. Il mancato conferimento dei dati per tali finalità avrà come unica conseguenza l’impossibilità di realizzare quanto da ultimo descritto.\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow13",
           "title": "Finalità (D):",
           "html":"Ove applicabile, i Contitolari Le forniranno tutte le informazioni necessarie sul trattamento dei suoi dati personali.",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow14",
           "title": "Finalità (E):",
           "html":"La base giuridica risiede nella necessità di adempiere un obbligo legale al quale sono soggetti i titolari del trattamento ex art. 6.1, lett. c) del GDPR.\r\nIl conferimento dei dati è obbligatorio per ottemperare agli obblighi di legge in materia di conservazione dei documenti amministrativi e contabili.\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow15",
           "title": "Modalità del trattamento",
           "html":"I dati saranno trattati con strumenti elettronici, digitali, informatici, telematici e anche analogici, nel pieno rispetto delle norme di legge, secondo principi di liceità e correttezza e in modo da tutelare la riservatezza. I dati personali, in ogni caso, non saranno oggetto di processo decisionale automatizzato.\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow16",
           "title": "Destinatari dei dati personali",
           "html":"I dati potrebbero essere inviati ad altri soggetti, quali:\r\n•\tPubbliche Amministrazioni e Autorità;\r\n•\tsoggetti terzi, nominati Responsabili del trattamento ai sensi dell’art. 28 del Regolamento (UE) 2016/679, con riferimento alla gestione di servizi o sistemi informatici o per altri servizi di consulenza.\r\nI dati personali non saranno trasferiti in un paese non appartenente allo Spazio Economico Europeo (ossia Unione Europea, oltre a Norvegia, Liechtenstein e Islanda).\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {
           "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow17",
           "title": "Diritti dell’interessato",
           "html":"Gli interessati hanno i diritti stabiliti dagli artt. 7,15-21 del GDPR, e, in particolare, il diritto:\r\n•\tdi revocare, in ogni momento, ogni eventuale consenso da liberamente manifestato, senza che ciò comporti alcun svantaggio o pregiudizio e senza pregiudicare la liceità del trattamento basata sul consenso prestato prima della revoca (diritto di revoca del consenso);\r\n•\tdi ottenere informazioni in relazione alle finalità per cui i suoi dati personali sono trattati, al periodo del trattamento e ai soggetti cui i dati sono comunicati (c.d. diritto di accesso);\r\n•\tdi ottenere la rettifica o integrazione dei dati personali inesatti che la riguardano (c.d. diritto di rettifica);\r\n•\tdi ottenere la cancellazione dei dati personali che la riguardano nei seguenti casi (a) i dati non siano più necessari per le finalità per le quali sono stati raccolti; (b) abbia ritirato il suo consenso al trattamento dei dati trattati sulla base del suo consenso; (c) si sia opposto al trattamento dei dati personali che lo riguardano nel caso in cui essi siano trattari per un nostro legittimo interesse; o (d) il trattamento dei suoi dati personali non sia conforme alla legge (e) i dati personali devono essere cancellati per adempiere un obbligo legale previsto dal diritto dell’Unione o dello Stato membro cui è soggetto il titolare del trattamento. Tuttavia, segnaliamo che la conservazione dei dati personali da parte del titolare è lecita qualora sia necessaria per consentire di adempiere un obbligo legale o per accertare, esercitare o difendere un diritto in sede giudiziaria (c.d. diritto di cancellazione);\r\n•\tdi ottenere che i dati personali che la riguardano siano solo conservati senza che di essi sia fatto altro uso nei seguenti casi (c.d. diritto di limitazione): (a) lei contesti l’esattezza dei dati personali, per il periodo necessario a consentirci di verificare l’esattezza di tali dati personali; (b) il trattamento sia illecito ma lei si opponga comunque alla cancellazione dei dati personali; (c) i dati personali siano a lei necessari per l’accertamento, l’esercizio o la difesa di un diritto in sede giudiziaria; (d) lei si sia opposto al trattamento e si sia in attesa della verifica in merito all’eventuale prevalenza dei nostri motivi legittimi al trattamento rispetto a quelli dell’interessato;\r\n•\tdi ottenere la cessazione del trattamento nei casi in cui i dati personali siano trattati per il nostro legittimo interesse e sia contestata l’esistenza di questo interesse (c.d. diritto di opposizione);\r\n•\tdi ricevere in un formato di uso comune, leggibile da dispositivo automatico e interoperabile i dati personali che la riguardano trattati con mezzi automatizzati, se essi siano trattati in forza di contratto o sulla base del consenso (c.d. diritto di portabilità).\r\nL’interessato potrà esercitare i diritti contattando i Contitolari ai recapiti sopra indicati.\r\nInfine, qualora l’interessato desideri proporre un reclamo in merito alle modalità attraverso cui i suoi dati sono trattati, ovvero in merito alla gestione di un reclamo proposto, ha il diritto di presentare un’istanza direttamente all’Autorità di controllo (Garante per la Protezione dei dati personali: www.gpdp.it) o di adire le opportune sedi giudiziarie (art. 79 del GDPR).\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },*/
       ],
       },
 
 
       {title: "Consenso al trattamento dei dati personali", elements: [
                      
         {  "id": uuidv4(),
           "name": "name",
           "type": "text",
           "title": "Nome",
           "isRequired": true,
           "disabled": true
         },
         {  "id": uuidv4(),
           "name": "surname",
           "type": "text",
           "title": "Cognome",
           "isRequired": true,
           "disabled": true
         },
         {  "id": uuidv4(),
           "name": "birth_date",
           "inputType": "date",
           "type": "datepicker",
           "title": "nata/o il",
           "dateFormat": "mm/dd/yy",
           "isRequired": true,
           "disabled": true,
           "config": {
            "changeMonth": true,
            "changeYear" : true,
            "yearRange": "1900:" + new Date().getFullYear(),
            "minDate": "01/01/1900",
            "maxDate": new Date().toISOString().split("T")[0]
           
        },
         },
  
         {  "id": uuidv4(),
           "name": "birth_place",
           "type": "text",
           "title": "a",
           "isRequired": true,
           "disabled": true
         },
         {  "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow176",
           "title": "DICHIARA",
           "html":"- di aver letto e compreso le su esposte informazioni, ivi comprese quelle relative al trattamento dei dati personali;\r\n\r\n- di aver compreso che la partecipazione allo studio è del tutto volontaria e libera, che ci si potrà ritirare dallo studio in qualsiasi momento, senza dover dare spiegazioni e senza che ciò comporti alcuno svantaggio o pregiudizio;\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
           "isRequired": true
         },
         
         {  "id": uuidv4(),
           "type": "boolean",
           "name": "acconsento_0",
           "title": "Conseguentemente, il/la sottoscritta:\r\nai sensi delle disposizioni del GDPR e del Decreto Legislativo 196/2003 e successive modifiche e integrazioni, e avendo letto le “Informazioni sul trattamento dei dati personali”\r\n",
           "description":"",
           "labelTrue": "Acconsento",
           "labelFalse": "Non Acconsento",
           "isRequired": true
         },
 
         {  "id": uuidv4(),
           "type": "boolean",
           "name": "acconsento_1",
           "title":"al trattamento -- NECESSARIO al fine di partecipare al progetto in questione -- dei miei dati personali per scopi di ricerca scientifica e statistica nel modo e per i motivi descritti nel punto (A) della sezione “Finalità del trattamento” della suindicata informativa;",
           "description":"",
           "labelTrue": "Acconsento",
           "labelFalse": "Non Acconsento",
           "isRequired": true
           
         },
         {  "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow17w6",
           "title": "DICHIARA",
           "html":"alla conservazione e ulteriore utilizzo dei miei dati personali per la finalità di cui al punto (C) della sezione “Finalità del trattamento” della suindicata informativa\r\n\r\nCliccando su “Complete” acconsenti a partecipare allo studio\r\n",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
           "isRequired": true
         }
         
        ]},
        {title: "Ti ringraziamo per aver aderito al progetto.", description: "Prima di procedere con il questionario sulle tue opinioni da esperto, ti chiediamo di rispondere ad alcune brevi domande di carattere generale", elements: [
                                           
                                                       
         {  "id": uuidv4(),
           "name": "role",
           "type": "text",
           "title": "Ruolo professionale",
           "isRequired": true ,
           "disabled": true
         },
         {  "id": uuidv4(),
           "type": "radiogroup",
           "name": "gender",
           "title": "Qual è il tuo genere?",
           "isRequired": true,
           "choices": [
           "Maschio" ,
          "Femmina" ,
            "Preferisco non dirlo" 
           ],"disabled": true
         },
         {  "id": uuidv4(),
           "name": "workplace",
           "type": "text",
           "title": "Affiliazione",
           "isRequired": true
           ,"disabled": true
         },
         {  "id": uuidv4(),
           "name": "working_country",
           "type": "text",
           "title": "Luogo di lavoro (Paese)",
           "isRequired": true
           ,"disabled": true
         },
         {
          "id": uuidv4(),
          type: "dropdown",
          name: "skilled_in1",
          title: "Area di expertise principale",
          isRequired: true,
          choices: [
            "Redditi, disuguaglianza e povertà",
            "Tassazione",
            "Lavoro",
            "Conti pubblici",
            "Imprese, concorrenza e regolamentazione",
            "Energia e ambiente",
            "Inflazione e politica monetaria",
            "Infrastrutture e trasporti",
            "Demografia e immigrazione",
            "Istituzioni",
            "Politiche commerciali",
            "Divari territoriali",
            "Istruzione e ricerca",
            "Sanità",
            "Pensioni",
            "Banche, assicurazioni e mercati finanziari"
          ]
          ,"disabled": true
        },
 
 
 
        {
          "id": uuidv4(),
          type: "dropdown",
          name: "skilled_in2",
          title: "Area di expertise secondaria",
          isRequired: true,
          choices: [
            "Redditi, disuguaglianza e povertà",
            "Tassazione",
            "Lavoro",
            "Conti pubblici",
            "Imprese, concorrenza e regolamentazione",
            "Energia e ambiente",
            "Inflazione e politica monetaria",
            "Infrastrutture e trasporti",
            "Demografia e immigrazione",
            "Istituzioni",
            "Politiche commerciali",
            "Divari territoriali",
            "Istruzione e ricerca",
            "Sanità",
            "Pensioni",
            "Banche, assicurazioni e mercati finanziari"
          ]
          ,"disabled": true
        },
 
        {
          "id": uuidv4(),
          type: "dropdown",
          name: "skilled_in3",
          title: "Area di expertise terziaria",
          isRequired: false,
          choices: [
            "Redditi, disuguaglianza e povertà",
            "Tassazione",
            "Lavoro",
            "Conti pubblici",
            "Imprese, concorrenza e regolamentazione",
            "Energia e ambiente",
            "Inflazione e politica monetaria",
            "Infrastrutture e trasporti",
            "Demografia e immigrazione",
            "Istituzioni",
            "Politiche commerciali",
            "Divari territoriali",
            "Istruzione e ricerca",
            "Sanità",
            "Pensioni",
            "Banche, assicurazioni e mercati finanziari"
          ],
          disabled: true
        }
        ]}
 
      /* {title: "Modulo Informativo per la partecipazione", elements: [
         {  "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow18",
           "title": "1. Titolo, Responsabile progetto",
           "html":"Gentile partecipante,Lei è invitata/o a prendere parte a una ricerca denominata “The Floor to the Experts”, condotta dal Dipartimento di Scienze Economiche dell’Alma Mater Studiorum – Università di Bologna (responsabile Prof. Guglielmo Barone), in collaborazione con Prometeia S.p.A. e la Fondazione GRINS, nell’ambito del progetto “GRINS – Growing Resilient, Inclusive and Sustainable”, finanziato dal PNRR nello spettro delle scienze economiche-politico-sociali e delle scienze dei dati, al fine di fornire evidenze che orientino le politiche pubbliche, nonché le scelte di cittadini e aziende in contesti decisionali complessi, contribuendo a una crescita del Paese più resiliente, inclusiva e sostenibile.\r\nPrima di decidere se partecipare è importante che abbia tutte le informazioni necessarie per aderire in modo consapevole e responsabile. Le chiediamo di leggere questo documento e di fare a chi le ha proposto questo studio tutte le domande che ritiene opportune.",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {  "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow124",
           "title": "2. Breve descrizione e Obiettivi",
           "html":"Il progetto di ricerca “The Floor to the Experts” persegue l’obiettivo di comprendere le opinioni di diversi esperti di economia, provenienti dal mondo dell'accademia, delle istituzioni e dell'industria, su vari temi economici e finanziari di attuale dibattito. Per raggiungere questo obiettivo, i ricercatori impegnati nel progetto si propongono di raccogliere e analizzare le risposte dei partecipanti a un breve sondaggio online.",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {  "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow19",
           "title": "3. Cosa comporta la partecipazione allo studio?",
           "html":"La partecipazione al progetto di ricerca “The Floor to the Experts” consiste nel rispondere a un questionario online nel quale il soggetto dovrà esprimere un’opinione su vari temi economici e finanziari di attuale dibattito a cadenza mensile.",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {  "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow20",
           "title": "4. Benefici, disagi e/o rischi potenziali della partecipazione",
           "html":"La partecipazione allo studio è volontaria e gratuita. Per i partecipanti la collaborazione non comporta nessun tipo di rischio o disagio. I ricercatori si attendono informazioni sull’ opinione del partecipante circa vari temi economici e finanziari di attuale dibattito.",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {  "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow21",
           "title": "5. Ritiro dallo studio",
           "html":"Lei ha il diritto di ritirare in qualsiasi momento il suo consenso alla partecipazione a questo studio, anche senza preavviso o motivazione specifica.",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {  "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow215",
           "title": "6. Restituzione",
           "html":"Lei ha diritto a richiedere informazioni sui risultati e sull’esito della ricerca.",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {  "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow22",
           "title": "7. Misure previste per tutelare l’anonimato",
           "html":"L’elaborazione dei dati raccolti sarà condotta in modo da eliminare qualsiasi riferimento che possa permettere di ricollegare singole affermazioni a una determinata persona. I risultati della ricerca saranno pubblicati in forma riassuntiva e in nessun caso eventuali brevi citazioni saranno riconducibili a singole persone. ",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         },
         {  "id": uuidv4(),
           "type": "html",
           "name": "suggestions-auto-grow2992",
           "title": "8. Contatti",
           "html":"Per qualsiasi informazione e chiarimento su questo studio o per qualsiasi necessità può rivolgersi al Dott. Federico Maggio dell’Alma Mater Studiorum – Università di Bologna – federico.maggio3@unibo.it -- che è a sua disposizione per ulteriori informazioni o chiarimenti.",
           "rows": 2,
           "autoGrow": true,
           "allowResize": false,
           "readOnly": true,
         }
        ]}*/
 
     ],
   };

  const [survey, setSurvey] = useState(cleanSurveyState);

  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const addNewPage = () => {
    setSurvey((prevSurvey) => ({
      ...prevSurvey,
      pages: [
        ...prevSurvey.pages,
        { title: `Page ${prevSurvey.pages.length + 1}`, elements: [] },
      ],
    }));
    setCurrentPageIndex(survey.pages.length); // Vai alla nuova pagina
  };

  const goToNextPage = () => {
    if (currentPageIndex < survey.pages.length - 1) {
      setCurrentPageIndex(currentPageIndex + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPageIndex > 0) {
      setCurrentPageIndex(currentPageIndex - 1);
    }
  };

  const removePage = (pageIndex) => {
    if (survey.pages.length > 1) {
      setSurvey((prevSurvey) => {
        const updatedPages = prevSurvey.pages.filter((_, index) => index !== pageIndex);
        const newPageIndex = pageIndex > 0 ? pageIndex - 1 : 0;
        setCurrentPageIndex(newPageIndex);
        return {
          ...prevSurvey,
          pages: updatedPages,
        };
      });
    } else {
      toast({
        title: t('toastMsg.surveyCreator.cannotDeleteLastPage'),
        status: "warning",
        duration: 2000,
        isClosable: true,
      });
    }
  };

  const addElementToCurrentPage = (elementType) => {
    setSurvey((prevSurvey) => {
      const updatedPages = [...prevSurvey.pages];
      updatedPages[currentPageIndex].elements.push({
        type: elementType,
        id: uuidv4(),
        ...(elementType === "html" && { html: "Inserisci il tuo codice html qui..." , readOnly: true})
      });
      return { ...prevSurvey, pages: updatedPages };
    });
  };

  const handleTitleChange = (e) => {
    const newTitle = e.target.value;
    setSurvey((prevSurvey) => ({ ...prevSurvey, title: newTitle }));
  };

  const handleDescriptionChange = (e) => {
    const newDescription = e.target.value;
    setSurvey((prevSurvey) => ({ ...prevSurvey, description: newDescription }));
  };

  const handlePageTitleChange = (e) => {
    const newPageTitle = e.target.value;
    setSurvey((prevSurvey) => {
      const updatedPages = [...prevSurvey.pages];
      updatedPages[currentPageIndex] = { ...updatedPages[currentPageIndex], title: newPageTitle };
      return { ...prevSurvey, pages: updatedPages };
    });
  };
  const handleCloseModal = () => {
    setModalPreviewOpen(false); // Chiude il modale
  };
  return (
    <ChakraProvider>
      <DndProvider backend={HTML5Backend}>
        <Flex height="100vh" direction="row" width="100%">
          {/* Main Content Area */}
          <MainContentArea
            survey={survey}
           
            setSurvey={setSurvey}
            currentPageIndex={currentPageIndex}
            addElementToCurrentPage={addElementToCurrentPage}
            handleTitleChange={handleTitleChange}
            handleDescriptionChange={handleDescriptionChange}
          
          />


            <Modal onClose={onCloseModalDiscardChangesSurvey} isOpen={isOpenModalDiscardChangesSurvey} isCentered closeOnOverlayClick={false} >
                            <ModalOverlay />
                            <ModalContent>
                              <ModalHeader>   {t('survey.confirmExitUpdateSurveyWithoutSavingMessage')} </ModalHeader>
                              <ModalBody></ModalBody>
                              <ModalFooter>
                                <Button colorScheme='green' mr={3} onClick={()=> {
                                  setSurvey(cleanSurveyState);
                                  setCurrentPageIndex(0);
                                 navigate("/surveys-consensus?hideHeader=true&hideNavbar=true")
                                
                                 
                                }}>
                                   {t('survey.tableGroup.yes')}
                                </Button>
                                <Button colorScheme='red' onClick={onCloseModalDiscardChangesSurvey}>
                                  No
                                </Button>
                              </ModalFooter>
                            </ModalContent>
                          </Modal>

          {/* Sidebar */}
          <Sidebar
           navigate={navigate}
            toast={toast}
            id={id}
            setCurrentPageIndex= {setCurrentPageIndex}
            survey={survey}
            setSurvey={setSurvey}
            options={options}
            goToPreviousPage={goToPreviousPage}
            goToNextPage={goToNextPage}
            addNewPage={addNewPage}
            currentPageIndex={currentPageIndex}
            totalPages={survey.pages.length}
            removePage={removePage} // Passiamo la funzione removePage
            setModalPreviewOpen={setModalPreviewOpen}
            handlePageTitleChange={handlePageTitleChange}

        
            setIsDraft={setIsDraft}
            onOpenModalDiscardChangesSurvey={onOpenModalDiscardChangesSurvey}
          />

<SurveyPreviewModal
 isConsensus={true}
        surveyConfig={survey} // Passa la configurazione del sondaggio
        isOpen={isModalPreviewOpen} // Stato di apertura/chiusura
        onClose={handleCloseModal} // Funzione per chiudere
      />

{isModalSaveSurveyOpen && (


<SaveUpdateSurveyModal
        surveyStructure={survey} // Passa la configurazione del sondaggio
        isOpen={isModalSaveSurveyOpen} // Stato di apertura/chiusura
        onClose={()=> setModalSaveSurveyOpen(false)} // Funzione per chiudere
        isDraft={isDraft}
      />)}
        </Flex>
      </DndProvider>
    </ChakraProvider>
  );
}

function MainContentArea({ survey, setSurvey, addElementToCurrentPage, currentPageIndex, handleTitleChange, handleDescriptionChange }) {
  const {t} = useTranslation();
  const updatePageSurvey = (pageIndex, elementId, identifier, val) => {

    setSurvey((prevSurvey) => {
      const updatedPages = [...prevSurvey.pages];
      const targetPage = updatedPages[pageIndex];
      const elementIndex = targetPage.elements.findIndex((element) => element.id === elementId);
      if (elementIndex !== -1) {
        const updatedElement = {
          ...targetPage.elements[elementIndex],
          [identifier]: val,
        };
        targetPage.elements = [
          ...targetPage.elements.slice(0, elementIndex),
          updatedElement,
          ...targetPage.elements.slice(elementIndex + 1),
        ];
        updatedPages[pageIndex] = targetPage;
      }
      return {
        ...prevSurvey,
        pages: updatedPages,
      };
    });
  };

  const copyElement = (index) => {
    setSurvey((prevSurvey) => {
      const updatedPages = [...prevSurvey.pages];
      const elements = updatedPages[currentPageIndex].elements;
  
      // Crea una copia dell'elemento selezionato e assegna un nuovo id
      const elementCopy = { ...elements[index], id: uuidv4() };
  
      // Aggiunge la copia alla fine della lista degli elementi
      elements.push(elementCopy);
  
      return { ...prevSurvey, pages: updatedPages };
    });
  
    // Scorri verso la fine solo se il riferimento è disponibile
    
  };

 // Funzione di copia profonda utilizzando structuredClone con fallback
const deepClone = (obj) => (typeof structuredClone === "function" ? structuredClone(obj) : JSON.parse(JSON.stringify(obj)));

const moveElementUp = (index) => {
  setSurvey((prevSurvey) => {
    // Verifica che prevSurvey, pages e l'indice corrente siano validi
    if (!prevSurvey || !prevSurvey.pages || !prevSurvey.pages[currentPageIndex]) return prevSurvey;

    // Copia profonda delle pagine per garantire che i cambiamenti siano rilevati
    const updatedPages = deepClone(prevSurvey.pages);
    const elements = updatedPages[currentPageIndex].elements;

    // Controllo di validità per evitare di spostare un elemento già al primo posto
    if (index <= 0) return prevSurvey;

    // Rimuove l'elemento dalla posizione corrente e reinserisce una copia profonda alla posizione superiore
    const element = deepClone(elements[index]);
    elements.splice(index, 1);
    elements.splice(index - 1, 0, element);

    return { ...prevSurvey, pages: updatedPages };
  });
};

const moveElementDown = (index) => {
  setSurvey((prevSurvey) => {
    // Verifica che prevSurvey, pages e l'indice corrente siano validi
    if (!prevSurvey || !prevSurvey.pages || !prevSurvey.pages[currentPageIndex]) return prevSurvey;

    // Copia profonda delle pagine per garantire che i cambiamenti siano rilevati
    const updatedPages = deepClone(prevSurvey.pages);
    const elements = updatedPages[currentPageIndex].elements;

    // Controllo di validità per evitare di spostare un elemento già in fondo
    if (index >= elements.length - 1) return prevSurvey;

    // Rimuove l'elemento dalla posizione corrente e reinserisce una copia profonda alla posizione inferiore
    const element = deepClone(elements[index]);
    elements.splice(index, 1);
    elements.splice(index + 1, 0, element);

    return { ...prevSurvey, pages: updatedPages };
  });
};

  
  const removeElement = (index) => {
    setSurvey((prevSurvey) => {
      const updatedPages = [...prevSurvey.pages];
      const elements = updatedPages[currentPageIndex].elements;
  
      // Controlla che l'array non sia vuoto e che l'indice sia valido
      if (elements.length === 0 || index < 0 || index >= elements.length) return;
  
      // Rimuove l'elemento in base all'indice
      elements.splice(index, 1);
  
      return { ...prevSurvey, pages: updatedPages };
    });
  };
  


  const [, drop] = useDrop({
    accept: "FORM_ELEMENT",
    drop: (item) => addElementToCurrentPage(item.name),
  });

  return (
    <Flex direction="column" flex="1" height="100vh">
<Box bg="white" p={2} boxShadow="sm" zIndex="10">
  {/* Survey Details Title */}
  <Text fontSize="md" fontWeight="bold" color={"rgba(11,78,90,255)"} >
    {t('survey.surveyCreation')}
  </Text>
  
  {/* Flex container for inputs */}
  <Flex gap={2} align="inline" mt={1} ml={4}>
    {/* Survey Title */}
    <Box flex="1" maxW="50%">
      <Text fontSize="sm" fontWeight="bold" mb={1}>
        {t('survey.surveyTitle')}
      </Text>
      <Input
        value={survey.title}
        onChange={handleTitleChange}
        placeholder={t('survey.enterSurveyTitle')}
        fontSize="sm"
        h="7"
        px="2"
      />
    </Box>

    {/* Survey Description */}
    <Box flex="1" maxW="50%">
      <Text fontSize="sm" fontWeight="bold" mb={1}>
        {t('survey.surveyDescription')}
      </Text>
      <Textarea
        value={survey.description}
        onChange={handleDescriptionChange}
        placeholder={t('survey.enterSurveyDescription')}
        fontSize="sm"
        h="7"
        resize="none"
        px="2"
      />
    </Box>
  </Flex>
</Box>



      <Box ref={drop} flex="1" overflowY="auto" p={4} pb={16}  bgColor={"#f6f3ec"} mt={1}>
        <VStack align="start" spacing={4} width="100%" mb={4}>
          {survey.pages[currentPageIndex].elements.map((element, index) => (
            <Box
              key={element.id}
              border="1px solid"
              borderColor="gray.300"
              borderRadius="md"
              padding="4"
              width="100%"
              bg="white"
            >
              <Box mb="2" fontWeight="bold" color="gray.600">
                {t('survey.question')} {index + 1}
              </Box>


              
{element.type === "text" && 
  <DraggableTextCreationElement 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => {  updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />

}

{element.type === "radiogroup" && 
  <DraggableRankingDropdownRadiogroupCheckboxCreationElement 
    name="radiogroup" 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}

{element.type === "dropdown" && 
  <DraggableRankingDropdownRadiogroupCheckboxCreationElement 
    name="dropdown" 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}

{element.type === "datepicker" && 
  <DraggableDatePickerCreationElement
    name="datepicker" 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}


{element.type === "html" && 
  <DraggableHtmlCreationElement 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}




{element.type === "boolean" && 
  <DraggableBooleanCreationElement 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}


            </Box>
          ))}
                    
        </VStack>
      </Box>
    </Flex>
  );
}

function Sidebar({navigate,toast, id,survey,setSurvey, options, goToPreviousPage, goToNextPage, addNewPage, currentPageIndex, totalPages, removePage , setModalPreviewOpen ,setCurrentPageIndex,handlePageTitleChange, onOpenModalDiscardChangesSurvey, setIsDraft}) {
  const {t} = useTranslation();
  return (
<Box
  width={{ base: "100%", md: "200px", lg: "300px" }}
  bg="gray.50"
  padding="2"
  boxShadow="xl"
  height="100vh"
  borderRadius="md"
  display="flex"
  flexDirection="column"
>
  {/* Contenuto scrollabile principale */}
  <Box
    flex="6"
    overflow="auto" /* Scroll verticale e orizzontale */
    mb={2}
  >
    {/* Primo Box responsivo */}
    <Box
      width="100%"
      minHeight="20vh"
      bg="white"
      padding={2}
      border="1px solid"
      borderColor="gray.300"
      borderRadius="md"
      boxShadow="sm"
      mb={0.5}
      overflow="auto"
    >
      <Text
        fontSize={{ base: "xs", md: "sm" }}
        fontWeight="bold"
        mb={2}
        textAlign="center"
        color="gray.800"
      >
        {t('survey.sideBar.dragNewQuestion')}
      </Text>
      <Table variant="simple" size="xs">
        <Thead>
          <Tr>
            <Th
              textAlign="center"
              color="gray.600"
              fontSize="xs"
              paddingY={1}
            >
              {t('survey.sideBar.questionTypes')}
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {options.map((option, index) => (
            <DraggableTableRow key={index} option={option} />
          ))}
        </Tbody>
      </Table>
    </Box>

    <Divider mb={0.5} width="100%" borderColor="gray.300" />

    {/* Secondo Box responsivo */}
    <Box
  width="100%"
  maxHeight={{ base: "45vh", md: "35vh" }}
  bg="white"
  padding={3}
  border="1px solid"
  borderColor="gray.300"
  borderRadius="md"
  boxShadow="sm"
  overflow="auto" /* Abilita scrolling */
>
      <Text
        fontSize={{ base: "sm", md: "md" }}
        fontWeight="bold"
        mb={0.1}
        textAlign="center"
        color="gray.800"
      >
        {t('survey.sideBar.pages')}
      </Text>
      <Text textAlign="center" mb={3} fontSize="sm">
        {t('survey.sideBar.page')} {currentPageIndex + 1} {t('survey.sideBar.of')} {totalPages}
      </Text>

      <Text fontSize="sm" fontWeight="bold" mb={2}>
        {t('survey.sideBar.pageTitle')}
      </Text>
      <Input
        value={survey.pages[currentPageIndex].title}
        onChange={handlePageTitleChange}
        placeholder={t('survey.sideBar.enterPageTitle')}
        fontSize="sm"
        mb={3}
      />

      <Button
        onClick={goToPreviousPage}
        isDisabled={currentPageIndex === 0}
        mb={2}
        size="md"
        width="100%"
      >
        {t('survey.sideBar.previousPage')}
      </Button>
      <Button
        onClick={goToNextPage}
        isDisabled={currentPageIndex === totalPages - 1}
        mb={2}
        size="md"
        width="100%"
      >
        {t('survey.sideBar.nextPage')}
      </Button>
      <Button
        onClick={addNewPage}
        size="md"
        width="100%"
        mb={2}
      >
        {t('survey.sideBar.addNewPage')}
      </Button>
      <Button
        onClick={() => removePage(currentPageIndex)}
        isDisabled={totalPages === 1}
        colorScheme="red"
        size="md"
        width="100%"
      >
        {t('survey.sideBar.removeCurrentPage')}
      </Button>
    </Box>
  </Box>

  {/* Azioni sempre visibili */}
  <Box
    bg="white"
    borderTop="1px solid"
    borderColor="gray.300"
    boxShadow="sm"
    position="sticky"
    bottom="0"
    padding={4}
    zIndex="1"
  >
    <Text
      fontSize={{ base: "sm", md: "md", lg: "lg" }}
      fontWeight="bold"
      mb={2}
      textAlign="center"
      color="gray.800"
    >
      {t('survey.sideBar.actions')}
    </Text>

    <Grid
      templateColumns="repeat(4, 1fr)"
      gap={2}
      width="100%"
      justifyItems="center"
    >



<Tooltip label="GoBack" aria-label="Reset Tooltip">
        <IconButton
          icon={<ArrowBackIcon boxSize={6} />}
          colorScheme="red"
          aria-label="GoBack"
          onClick={() => {
          
            onOpenModalDiscardChangesSurvey()
             
          }}
          size="lg"
        />
      </Tooltip>
      <Tooltip label={t('survey.sideBar.saveDraft')} aria-label="Update Survey Consensus">
        <IconButton
          icon={<FaSave style={{ fontSize: "1.5em" }} />}
          colorScheme="orange"
          aria-label="Update Survey Consensus"
          onClick={() => {
            setIsDraft(true);

            
            let bodyCreateSurveyConsensus = {
              id_survey_info: id,
              owner: sessionStorage.getItem("username"),
              type: "private",
              survey_structure: survey
            }

            
            if (!bodyCreateSurveyConsensus.survey_structure.title || bodyCreateSurveyConsensus.survey_structure.title.trim().length === 0) {
              toast({
                title: "SurveyTitle is mandatory",
                description: "",
                position: "top",
                status: "warning",
                duration: 4000,
                isClosable: true,
            });
            return
            }

            updateSurveyConsensus(t,bodyCreateSurveyConsensus).then(res => {
            
             

                toast({
                  title: res.message.msg,
                  status: "info",
                  duration: 1400,
                  isClosable: true,
                  onCloseComplete : ()=> {
                     
                    navigate("/surveys-consensus?hideHeader=true&hideNavbar=true")
                  }
                  
                });

            })
          }}
          size="lg"
        />
      </Tooltip>

   

      <Tooltip label={t('survey.sideBar.preview')} aria-label="Preview Tooltip">
        <IconButton
          icon={<ViewIcon boxSize={6} />}
          colorScheme="green"
          aria-label="Preview"
          onClick={() => {
            setModalPreviewOpen(true);
          }}
          size="lg"
        />
      </Tooltip>

      <Tooltip label="Reset" aria-label="Reset Tooltip">
        <IconButton
          icon={<RepeatIcon boxSize={6} />}
          colorScheme="red"
          aria-label="Reset"
          onClick={() => {

            if(id != null) {
              getSurveyADP({id_survey_info: id }).then(res => {
                
        
                if(res && res.message && res.message.survey_structure) 
        
                  setSurvey(res.message.survey_structure)
              })    
                
            }
            setCurrentPageIndex(0);


          }}
          size="lg"
        />
      </Tooltip>
    </Grid>
  </Box>
</Box>


  
  
  
  );
}

function DraggableTableRow({ option }) {
  const [{ isDragging }, drag] = useDrag({
    type: "FORM_ELEMENT",
    item: { name: option },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <Tr ref={drag} opacity={isDragging ? 0.5 : 1}>
      <Th display="flex" alignItems="center">
        
        {option === "text" ? (
          
          <Icon as={ChatIcon} boxSize={5} marginRight="2" mt={4} />
        ) :
       
         option === "html" ? (
                  <Icon as={PiFileHtmlBold } boxSize={6} marginRight="2" />
                ) :
        option === "boolean" ? (
                  <Icon as={VscSymbolBoolean } boxSize={5} marginRight="2" />
                ):

                option === "dropdown" ? (
                  <Icon as={MdArrowDropDown} boxSize={5} marginRight="2" />
                ):
       
        
        (
          <Icon as={QuestionIcon} boxSize={5} marginRight="2" />
        )}
        {option}
      </Th>
    </Tr>
  );
}

export default SurveyConsensusUpdateComponent;
